// extracted by mini-css-extract-plugin
module.exports = {"buttons":"TerminalForm_buttons__3sYg4"};